export const Types = {
  OPEN_MODAL: '@modal/OPEN_MODAL',
  CLOSE_MODAL: '@modal/CLOSE_MODAL',
};

export function openModal(payload) {
  return {
    type: Types.OPEN_MODAL,
    payload,
  };
}

export function closeModal() {
  return {
    type: Types.CLOSE_MODAL,
  };
}
